import german from './languages/german/rulesList'

const languageGrammar = {
  'german': german,
}

export default languageGrammar


// WEBPACK FOOTER //
// ./src/browser/grammar/languageGrammar.js